const config = {
  MOVIE_DB_API_KEY: "7898ae46196f1a06340fe1b383b79cde",
  FIREBASE_API_KEY: "AIzaSyCON7l604183iUG3XD3gepWRQfFGuH6I-I",
};

export default config;
